/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { createLogger, createStore, useStore as VuexStore } from "vuex";
import { IRootState } from "./modules/root/state";
import { UserStoreModuleTypes } from "./modules/user";
import { AdminStoreModuleTypes } from "./modules/admin";
import { BotStoreModuleTypes } from "./modules/bot";

import { root, RootStoreModuleTypes } from "./modules/root";
import { InboxStoreModuleTypes } from "@/store/modules/inbox";

export const store = createStore<IRootState>({
  ...root,
  plugins: [createLogger()],
});

type StoreModules = {
  user: UserStoreModuleTypes;
  admin: AdminStoreModuleTypes;
  root: RootStoreModuleTypes;
  bot: BotStoreModuleTypes;
  inbox: InboxStoreModuleTypes;
};

export type Store = UserStoreModuleTypes<Pick<StoreModules, "user">> &
  AdminStoreModuleTypes<Pick<StoreModules, "admin">> &
  BotStoreModuleTypes<Pick<StoreModules, "bot">> &
  InboxStoreModuleTypes<Pick<StoreModules, "inbox">> &
  RootStoreModuleTypes<Pick<StoreModules, "root">>;

export function useStore(): Store {
  return VuexStore() as Store;
}
